import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

import { ProductSubNav } from "@/components/portal/ProductSubNav";
import { learningSubNav } from "@/lib/navigationItems";
import { usePermissions } from "@/hooks/usePermissions";

export const Route = createFileRoute("/portal/learning")({
  component: LearningLayout,
});

/**
 * Learning layout (`/portal/learning`) — the learner's "My tests", the result
 * page and manager review. Gated on the `lms` RBAC resource alone, with no
 * `user.is_admin` check: a team's reviewer is an ordinary org member. It shares
 * the one Learning tab strip with `/portal/lms` (the curator pages).
 *
 * The render is held while RBAC is resolving, because `can()` answers false
 * until then and would bounce a permitted user. Visibility is all this guard
 * decides — which attempts a caller may review is enforced per attempt by dp
 * lms (team object permission, 404 on any miss).
 */
function LearningLayout() {
  const { can, rbacResolving } = usePermissions();
  const navigate = useNavigate();
  const canView = can("view", "lms");

  useEffect(() => {
    if (!rbacResolving && !canView) {
      navigate({ to: "/portal" });
    }
  }, [rbacResolving, canView, navigate]);

  if (rbacResolving || !canView) {
    return null;
  }

  return (
    <div className="space-y-4">
      <ProductSubNav items={learningSubNav} />
      <Outlet />
    </div>
  );
}
